import { render } from "./App.vue?vue&type=template&id=b36e18c4"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import exportComponent from "/var/atlassian/application-data/bamboo/xml-data/build-dir/FS-GUI-BUILD/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__